// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { StoreActionApi } from '@atlassian/react-sweet-state';
import type { Props, State } from './FieldsUpdate.types.tsx';
import type { UpdateValueDecorationProps } from './UpdateValueDecorationProps.types.tsx';
import { updateInternal } from './updateInternal.tsx';

export const updateValueDecoration =
	(updateProps: UpdateValueDecorationProps) =>
	(
		{ getState, setState }: StoreActionApi<State>,
		{ fieldRemote, onDecorationUpdateFailed, createAnalyticsEvent }: Props,
	): void => {
		updateInternal(
			updateProps,
			fieldRemote,
			getState,
			setState,
			onDecorationUpdateFailed,
			createAnalyticsEvent,
		);
	};
